import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { BaseDataTableFilter } from '../../../../../../shared/components/data-table/filters/components/data-table-filter/BaseDataTableFilter';
import {PartnerOrgFilterStateService} from '../../../../services/partner-org-filter-state.service'
import { PartnerOrgMessageService } from '../../../../services/partner-org-message.service';
import { DataTableFilterMessageService } from '../../../../../../shared/components/data-table/filters/components/data-table-filter-message-service';
import { addFilterStatusToFilterStatusText } from '../../../../../../utilities/TableFilterUtility';

@Component({
  selector: 'app-partner-orgs-filter-status',
  imports: [
    CommonModule,
    MatSlideToggle
  ],
  templateUrl: './partner-orgs-filter-status.component.html',
  styleUrl: './partner-orgs-filter-status.component.scss'
})
export class PartnerOrgsFilterStatusComponent extends BaseDataTableFilter implements OnInit {

  constructor(
    private filterStateService: PartnerOrgFilterStateService,
    private partnerOrgMessageService: PartnerOrgMessageService,
    private filterMessageService: DataTableFilterMessageService
  ) {
    super(filterMessageService);
  }

  ngOnInit(): void {
    if (this.filterStateService.isStatusFilterActive()) {
      this.filterMessageService.setActive({ filterId: this.id, active: true, value: this.getFilterStatusText() });
    }
  }

  onActiveToggle(event: MatSlideToggleChange): void {
    this.filterStateService.active = event.checked;
  }

  onPendingActiveToggle(event: MatSlideToggleChange): void {
    this.filterStateService.pendingActive = event.checked;
  }

  onOnboardingInProgressToggle(event: MatSlideToggleChange): void {
    this.filterStateService.onboardingInProgress = event.checked;
  }

  onPendingInactiveToggle(event: MatSlideToggleChange): void {
    this.filterStateService.pendingInactive = event.checked;
  }

  onInactiveToggle(event: MatSlideToggleChange): void {
    this.filterStateService.inactive = event.checked;
  }

  onTerminatedToggle(event: MatSlideToggleChange): void {
    this.filterStateService.terminated = event.checked;
  }

  onDeletedToggle(event: MatSlideToggleChange): void {
    this.filterStateService.deleted = event.checked;
  }

  onStagingToggle(event: MatSlideToggleChange): void {
    this.filterStateService.staging = event.checked;
  }

  onApplyClicked(): void {
    if (this.filterStateService.allStatusFiltersDisabled() || this.filterStateService.allStatusFiltersEnabled()) {
      this.filterMessageService.setActive({ filterId: this.id, active: false });
    } else {
      this.filterMessageService.setActive({ filterId: this.id, active: this.filterStateService.isStatusFilterActive(), value: this.getFilterStatusText() });
    }
    this.partnerOrgMessageService.applyFilter();
  }

  onClearClicked(): void {
    this.filterStateService.resetStatusFilters();
    this.partnerOrgMessageService.applyFilter();
    this.filterMessageService.setActive({ filterId: this.id, active: false });
  }

  getStateService(): PartnerOrgFilterStateService {
    return this.filterStateService;
  }

  private getFilterStatusText(): any {
    let filterValue: string[] = [];
    addFilterStatusToFilterStatusText("ACTIVE", this.filterStateService.isActiveFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("PENDING ACTIVE", this.filterStateService.isPendingActiveFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("ONBOARDING IN PROGRESS", this.filterStateService.isOnboardingInProgressFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("PENDING INACTIVE", this.filterStateService.isPendingInactiveFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("INACTIVE", this.filterStateService.isInactiveFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("TERMINATED", this.filterStateService.isTerminatedFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("DELETED", this.filterStateService.isDeletedFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("STAGING", this.filterStateService.isStagingFilterActive(), filterValue);
    return filterValue;
  }
}
